/** @jsx jsx */
import { jsx } from '@emotion/core'
import { BaccaratBtnStyle } from '@views/Matchup/MatchField/MatchTab/index.style'
import BaccaratBtnImg from '@assets/images/casino/baccarat-btn.png'
import { Button } from '@styles/button.style'
import { isMobile } from 'react-device-detect'
import AdvCasino from '@views/AdvCasino'
import useRootStore from '@store/useRootStore'
import { loadOrReload } from '@utils/utils'

function AdvCasinoAdvertisementButton() {
  const { globalStore } = useRootStore()

  const onClickAdvCasinoHandler = () => {
    if (isMobile) {
      loadOrReload('/adv-casino')
    } else {
      globalStore.addGeneralPopupProperties(<AdvCasino/>, '승부사카지노', {
        wrapClassName: '',
        className: 'adv-casino',
        isScroll: true,
        custom: false,
        clsBtn: false,
      }, null, 'adv-casino-Advertisement-popup')
      globalStore.setVisibleSideBar(false)
    }
  }

  return (
    <Button TP css={BaccaratBtnStyle} onClick={onClickAdvCasinoHandler}>
      <div className="effect-bg"/>
      <div className="effect-bg pink"/>
      <img src={BaccaratBtnImg} alt="바카라" style={{ width: '50px' }}/>
      <div className="effect-box">
        <div className="circle-line">
          <span className="light-ani"/>
        </div>
      </div>
    </Button>
  )
}

export default AdvCasinoAdvertisementButton
